import React, { useState  } from 'react';

import { useTheme } from '@mui/material/styles';

import Styled from 'components/Styled/Styled';
import {ControlBanner} from './components/ControlBanner/ControlBanner';
import {ImageProvider} from './components/ImageContext/ImageContext';
import {Image} from './components/Image/Image';
import {Magnifier} from './components/Magnifier/Magnifier';
import {Highlights} from './components/Highlights/Highlights';
import {emit} from 'api/prokey/prokey.websocket';

//-----------------------------------------------------------------
export function ImagePanel( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES] === STATE

  const theme = useTheme();

  const [ settings, setSettings ] = useState({})

  const _styles = {
    container: {
      width      : '100%'     ,
      position   : 'relative' ,
      height     : 'calc( 100% )' ,
    },
  }

  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [EVENTS]

  function onChange_Settings() {

  }
  
  //-----------------------------------------------------------------
  function onMouseUp() {
    //-----------------------------------------------------------------
    emit( 'FILE_FIELD_FOCUS' );
  }

  //#endregion 

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Styled styles={[_styles.container]} onMouseUp={onMouseUp}>
        <ImageProvider>
          <ControlBanner onChange={setSettings} />
          <Styled styles={[{ position :'relative'},{ cursor: 'crosshair' }, { overflow:'auto' } ]}>
            <Image      settings={settings} />
            <Highlights settings={settings} />
            <Magnifier  settings={settings} />
          </Styled>
        </ImageProvider>
      </Styled>
    )
  }

  //#endregion
  
  return display();
}